/**
 * @license
 * Copyright 2023 Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
export class AppBarHelpButtonFoundation {
    constructor(_adapter) {
        this._adapter = _adapter;
        this._options = [];
        this._isInitialized = false;
    }
    initialize() {
        this._adapter.initialize();
        this._adapter.setMenuOptions(this._options);
        this._isInitialized = true;
    }
    disconnect() {
        this._isInitialized = false;
    }
    get options() {
        return this._options;
    }
    set options(value) {
        this._options = value.map(o => (Object.assign({}, o)));
        if (this._isInitialized) {
            this._adapter.setMenuOptions(value);
        }
    }
}
